export enum SortingType {
  Asceding,
  Desceding,
}
